import { useState, useEffect, useCallback } from "react";
import { changePasswordApi } from "../../../api/authApi";
import { syncStoredUser } from "../auth/authStorage";

export function useChangePassword(user, updatePortalUser) {
  const [showModal, setShowModal] = useState(false);
  const [required, setRequired] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (user?.must_change_password) {
      setRequired(true);
      setShowModal(true);
    }
  }, [user?.must_change_password]);

  const openChangePassword = useCallback(() => {
    setError("");
    setShowModal(true);
  }, []);

  const closeChangePassword = useCallback(() => {
    if (required) return;
    setShowModal(false);
    setError("");
  }, [required]);

  const handleChangePassword = useCallback(async (form) => {
    if (form.validationError) {
      setError(form.validationError);
      return;
    }
    setSaving(true);
    setError("");
    try {
      const { user: updatedUser } = await changePasswordApi({
        current_password: form.current_password,
        new_password: form.new_password,
      });
      syncStoredUser(updatedUser);
      updatePortalUser?.(updatedUser);
      setRequired(false);
      setShowModal(false);
    } catch (e) {
      setError(e.message || "Could not change password.");
    } finally {
      setSaving(false);
    }
  }, [updatePortalUser]);

  return {
    showChangePasswordModal: showModal,
    changePasswordRequired: required,
    changePasswordSaving: saving,
    changePasswordError: error,
    openChangePassword,
    closeChangePassword,
    handleChangePassword,
  };
}
